import { Component } from '@angular/core';

@Component({
  template: require('./medidas.component.html')
})
export class MedidasComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/medidas.component.ts
 **/